const urlName = '/usercenter/v2/t-b/branch'

export default (API) => ({
	// 获取用户机构
	getFindAdminBranchList() {
		return API({ url: `${urlName}/findMyBranch` })
	},
})
